import React from 'react'
import './styles.css'
import PropTypes from 'prop-types'

export class Wrapper extends React.Component {
  renderDeleteButton() {
    if (!this.props.isAdminButtonsVisible) {
      return null
    }

    return (
      <button id="DeletePool" className="btn btn-sm btn-danger mx-1" onClick={() => this.props.showDeletePoolModal()}>Delete</button>
    )
  }
  renderRestaurantsSyncButton() {
    if (!this.props.isAdminButtonsVisible) {
      return null
    }

    return (
      <button id="SyncPartnerRestaurantsDetails" className="btn btn-sm btn-info mx-1" onClick={() => this.props.showSyncRestaurantDetailsModal()}>Sync partner restaurants details</button>
    )
  }

  render() {
    return <React.Fragment>
      <div className={"container-fluid " + this.props.className}>
        <div className="page-header">
          <div className="row">
            <div className="col-6">
              <h1 className="page-title">{this.props.title}</h1>
            </div>
            <div className="col-6 d-flex flex-row-reverse">
              {this.props.toolbar}
              {this.renderDeleteButton()}
              {this.renderRestaurantsSyncButton()}
            </div>
          </div>
        </div>
        <div className="panel">
          <div className="panel-body">
            {this.props.children}
          </div>
        </div>
      </div>
    </React.Fragment>
  }
}

Wrapper.propTypes = {
  title: PropTypes.string,
  toolbar: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node,
  showDeletePoolModal: PropTypes.func,
  showSyncRestaurantDetailsModal: PropTypes.func,
  isAdminButtonsVisible: PropTypes.bool
}

export default Wrapper



// WEBPACK FOOTER //
// ./src/components/wrapper/index.js